import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@kcftech/design-system';
import { DebouncedSearchInput } from 'components/data/DebouncedSearchInput';
import { DocumentTitle } from 'components/DocumentTitle';
import { TablePageLayout } from 'components/page/styled';
import { usePermissions } from 'contexts/PermissionsContext';
import { usePagedBearingsDataSource } from 'custom_hooks/data_hooks/data_source/bearingsDataSource';
import { BearingsModal } from 'pages/Settings/Bearings/BearingsModal';
import { BearingsTable } from 'pages/Settings/Bearings/BearingsTable';
import { SearchCreateButtonContainer } from 'pages/Settings/shared/styled';
import { useEffect, useState } from 'react';
import { ContextualPageProps } from 'utils/types';

export function BearingsPage(_unusedProps: ContextualPageProps) {
    const { canAddBearings } = usePermissions();
    const dataSource = usePagedBearingsDataSource({
        name: 'bearings-table',
        defaultFilter: {
            nameSearch: '',
        },
    });
    const [addModalOpen, setAddModalOpen] = useState(false);
    const { setFilter, reset, reloadPage } = dataSource;
    const [nameSearch, setNameSearch] = useState('');

    const onBearingsCreate = () => {
        setAddModalOpen(false);
        reset();
        reloadPage();
    };

    useEffect(() => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            nameSearch,
        }));
    }, [nameSearch, setFilter]);

    return (
        <TablePageLayout>
            <DocumentTitle title="Bearings Settings" />
            <SearchCreateButtonContainer>
                <DebouncedSearchInput
                    placeholder="Search"
                    value={nameSearch}
                    onChange={setNameSearch}
                />
                {canAddBearings && (
                    <Button
                        appearance="primary"
                        spacing="medium"
                        icon={<FontAwesomeIcon icon={faPlus} />}
                        onClick={() => setAddModalOpen(true)}
                    >
                        Add
                    </Button>
                )}
                {addModalOpen && (
                    <BearingsModal
                        onCreate={onBearingsCreate}
                        onClose={() => setAddModalOpen(false)}
                    />
                )}
            </SearchCreateButtonContainer>
            <BearingsTable dataSource={dataSource} />
        </TablePageLayout>
    );
}
